import React, { Component } from 'react';

import styled from 'styled-components';
import {
  imageBasePath,
  dualPedigreeMode,
  dualPedigreeFlipPanelWidth
  // minimal,
} from '../../library/constants';
import {
  isMobilePhone,
  // isMobileTablet,
} from '../../library/calc';

export class ProgressBar extends Component {

  render () {

    return (

            <div style={{
              position: 'absolute',
              backgroundColor: '#78B957',
              // backgroundColor: 'red',
              bottom: '165px',
              width: `${this.props.progress.get('loaded')}%`,
              height: '8px',
              zIndex: 2,
            }}></div>
    )

  }
}

export class ProgressIndicator extends Component {

  render () {

    // let top = typeof(this.props.canvasTop) !== 'undefined' || minimal ? this.props.canvasTop: 63;
    // top -= 30;

/*
    const ProgressIndicatorOverlay = styled.div`
      width: 100%;
      height: 100%;
      text-align: center;
      position: fixed;
      top: ${( isMobilePhone() ? 0: top)}px;
      right: 0px;
      bottom: 0px;
      left: 0px;
      z-index: 999999999;
      background: white;
      opacity: .5;
    `;

 */
    const ProgressIndicatorOverlay = styled.div`
      width: 100%;
      height: 100%;
      text-align: center;
      position: fixed;
      top: 0px;
      right: 0px;
      bottom: 0px;
      left: 0px;
      z-index: 999999999;
      background: white;
      opacity: .5;
    `;

    const imgSize = ( isMobilePhone() ? 22 : 12);

    let imgStyle = {
      maxHeight: `${imgSize}%`,
      maxWidth: `${imgSize}%`,
      width: 'auto',
      height: 'auto',
      position: 'absolute',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      margin: 'auto',
    }

    if( dualPedigreeMode ){

         console.log(`%c dualPedigreeMode`, [
           'color: white',
           'background: orange',
           'font-size: 14px',
           'border: 5px solid red',
           'padding: 10px',
           ].join(';'));

      const widthOfSpinnder = 75
      let leftMargin = (( window.innerWidth) / 2) - widthOfSpinnder;
      imgStyle = {
          ...imgStyle,
          margin: `auto 0px auto ${leftMargin}px`,
      }
    }

    return (
      <ProgressIndicatorOverlay>
        <img id="progressIndicator" alt="" src={imageBasePath + 'loading.gif' } style={imgStyle}/>
      </ProgressIndicatorOverlay>
    )}
}

